import { createContext } from 'react-router';

/**
 * React Router context for correlation ID (request-scoped, used in middleware and loaders)
 */
export const correlationContext = createContext<string>('');

/**
 * Generate a new correlation ID using crypto.randomUUID()
 */
export function generateCorrelationId(): string {
    return crypto.randomUUID();
}
